module.exports = __webpack_public_path__ + "static/img/hand.311cd163.png";